module.exports = ".tooltip-handling\n{\n   width: 89%;\n   position: relative;\n}\n.drop-tooltip {\n    right: -44px;\n    border-bottom: 2px solid black;\n    padding-left: 0;\n    top: 2px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dropdown/dropdown.component.css
// module id = 525
// module chunks = 2